<div class="motors-description-and-photos-page">
    <tg-row>
        <tg-col md="8">
            <h1 class="motors-listing-details-page__title">
                Add your description and photos
            </h1>
        </tg-col>
        <tg-col md="4">
            <motors-cannot-edit-something-message-section [isDescriptionAndPhotos]="true">
            </motors-cannot-edit-something-message-section>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col
            class="motors-description-and-photos-page__section--padding-bottom"
        >
            <motors-description-and-photos-description-section></motors-description-and-photos-description-section>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col>
            <p class="p-lead-copy">Photos and video</p>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col
            class="motors-description-and-photos-page__section--padding-bottom"
        >
            <motors-description-and-photos-photo-section></motors-description-and-photos-photo-section>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col
            class="motors-description-and-photos-page__section--padding-bottom"
        >
            <motors-description-and-photos-video-section></motors-description-and-photos-video-section>
        </tg-col>
    </tg-row>
</div>
